module.exports = __webpack_public_path__ + "img/media-9.e66ccb59.png";